new MutationObserver((mutations, observer) => {
  if (document.getElementById("cart").classList.contains("cart--empty")) {
    document.getElementById("site-cart-sidebar").classList.add("cart-is-empty");
  } else {
    document
      .getElementById("site-cart-sidebar")
      .classList.remove("cart-is-empty");
  }
}).observe(document.querySelector(".cart-form"), {
  attributes: false,
  childList: true,
  subtree: true,
});

document.addEventListener("DOMContentLoaded", function () {
  addPopupEventListeners();
  addDiscountTextToggleEventListeners();
  
  document.body.addEventListener("submit", async function (event) {
    if (event.target.matches("form[recommended-product-form]")) {
      event.preventDefault();

      const form = event.target;

      await fetch("/cart/add", {
        method: "post",
        body: new FormData(form),
      });

      await updateCart();
      addEventListeners();
    }
  });
});

async function updateCart() {
  const res = await fetch("/?section_id=sidebar-drawer");
  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;

  const newSidebar = html.querySelector("#site-cart-sidebar");

  if (newSidebar) {
    const primaryItems = newSidebar.querySelectorAll('.primary-item');

    const validPrimaryItems = Array.from(primaryItems).filter(item => {
      return item.dataset.notAFrame !== 'true';
    });
    
    const currentSidebar = document.querySelector("#site-cart-sidebar");
    currentSidebar.innerHTML = newSidebar.innerHTML;
    
    if (validPrimaryItems.length === 1) {
      currentSidebar.classList.add('fifty-percent-discount');
    } else {
      currentSidebar.classList.remove('fifty-percent-discount');
    }
    
    if (validPrimaryItems.length === 0 && !currentSidebar.classList.contains('cart-is-empty')) {
      currentSidebar.classList.add('cart-is-empty');
    }
    
    addEventListeners();
  } else {
    console.error("Error: Could not find the updated content for #site-cart-sidebar");
  }
}

window.addEventListeners = function() {
  const accordions = document.querySelectorAll("#site-cart-sidebar [accordion]");
  const closeButton = document.querySelector('#sidebar-close');

  accordions.forEach((accordion) => {
    accordion.addEventListener("click", handleAccordionClick);
  });

  if (closeButton) {
    closeButton.addEventListener('click', hideCartDrawer);
  }

  addPopupEventListeners();
  addDiscountTextToggleEventListeners();
}

window.addPopupEventListeners = function() {
  setupPopup({
    triggerSelector: '.learn-more-cart',
    popupSelector: '.upgrade-diamond-plan-popup',
    hasVideo: true
  });

  setupPopup({
    triggerSelector: '.learn-more-subscribe-save',
    popupSelector: '.subscribe-save-popup',
    hasVideo: false
  });

  setupPopup({
    triggerSelector: '.suscripcion-popup-link',
    popupSelector: '.subscribe-save-popup',
    hasVideo: false
  });
}

function setupPopup({ triggerSelector, popupSelector, hasVideo = false }) {
  const triggerButtons = document.querySelectorAll(triggerSelector);
  const popup = document.querySelector(popupSelector);
  const darkOverlay = document.querySelector('.cart-dark-overlay');

  function closePopup() {
    if (hasVideo) {
      const video = popup?.querySelector('video');
      const playIcon = popup?.querySelector('.icon-play');
      
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
      
      if (playIcon) {
        playIcon.classList.remove('display-none');
        playIcon.classList.add('display-block');
      }
    }
    
    if (popup) {
      popup.classList.remove('display-flex');
      popup.classList.add('display-none');
    }
    
    if (darkOverlay) {
      darkOverlay.classList.remove('display-block');
      darkOverlay.classList.add('display-none');
    }
  }

  triggerButtons.forEach(button => {
    button.addEventListener('click', () => {
      if (popup) {
        popup.classList.remove('display-none');
        popup.classList.add('display-flex');
      }
      if (darkOverlay) {
        darkOverlay.classList.remove('display-none');
        darkOverlay.classList.add('display-block');
      }
    });
  });

  const closeButton = popup?.querySelector('.icon-blue-close');
  if (closeButton) {
    closeButton.addEventListener('click', closePopup);
  }

  if (darkOverlay) {
    darkOverlay.addEventListener('click', (event) => {
      if (event.target === darkOverlay) {
        closePopup();
      }
    });
  }

  if (hasVideo) {
    const videoContainer = popup?.querySelector('.video-container');
    if (videoContainer) {
      const video = videoContainer.querySelector('video');
      const playIcon = videoContainer.querySelector('.icon-play');

      videoContainer.addEventListener('click', () => {
        if (video.paused) {
          video.play();
          playIcon.classList.remove('display-block');
          playIcon.classList.add('display-none');
        } else {
          video.pause();
          playIcon.classList.remove('display-none');
          playIcon.classList.add('display-block');
        }
      });
    }
  }
}

window.addDiscountTextToggleEventListeners = function() {
  const discountSections = document.querySelectorAll('.fifty-percent-discount-section');
  
  discountSections.forEach(section => {
    const shortText = section.querySelector('.discount-short-text');
    const longText = section.querySelector('.discount-long-text');
    const closeIcon = section.querySelector('.icon-cross');
    
    if (shortText && longText) {
      shortText.classList.remove('collapsed');
      longText.classList.remove('expanded');
      
      shortText.addEventListener('click', () => {
        shortText.classList.add('collapsed');
        longText.classList.add('expanded');
      });
      
      longText.addEventListener('click', () => {
        longText.classList.remove('expanded');
        shortText.classList.remove('collapsed');
      });
    }
    
    if (closeIcon) {
      closeIcon.addEventListener('click', () => {
        section.classList.add('hidden');
      });
    }
  });
}

function handleAccordionClick(event) {
  const accordion = event.currentTarget;
  const accordions = document.querySelectorAll("#site-cart-sidebar [accordion]");

  if (accordion.classList.contains("active")) {
    accordion.classList.remove("active");
  } else {
    accordions.forEach((a) => a.classList.remove("active"));
    accordion.classList.add("active");
  }
}

function hideCartDrawer() {
  document.getElementById('site-cart-sidebar')?.hide();
}
